import React from 'react';
import { useTheme } from 'styled-components';
import { QuizLayout } from '@skooldio/skooldio-classroom-components';
import PropTypes from 'prop-types';

import { useConfig } from 'Context/ConfigContext';
import { Box } from 'Components/Base';
import { useOffset } from 'Context/LayoutContext/OffsetProvider';

const QuizWrapper = ({ children, outerProps, ...props }) => {
  const {
    classroom: { quiz = {} },
  } = useConfig();
  const { bgColor = 'primary' } = quiz;
  const { colors } = useTheme();
  const { topOffset, bottomOffset } = useOffset();
  const totalOffset = topOffset + bottomOffset;
  return (
    <Box pt={`${topOffset}px`} pb={`${bottomOffset}px`} {...outerProps}>
      <Box
        style={{ position: 'absolute', top: 0, backgroundColor: colors[bgColor] }}
        width={1}
        height={`${topOffset}px`}
      />

      <QuizLayout height={`calc(100vh - ${totalOffset}px)`} {...props}>
        {children}
      </QuizLayout>
    </Box>
  );
};

QuizWrapper.propTypes = {
  outerProps: PropTypes.object,
};

export default QuizWrapper;
